import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { Upload } from '@smartflip/data-models';
import { UploadService } from 'apps/app/src/app/shared/services/upload.service';

@Component({
  selector: 'smartflip-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, IonicModule],
})
export class UploadFormComponent implements OnInit {
  imgUrl: string;
  propertyId: string;
  selectedFile: FileList;
  currentUpload: Upload;
  imageForm: UntypedFormGroup;
  data: { propertyId: string; imgUrl: string };
  tooltipText =
    'System Preferences > Security & Privacy > Privacy Tab > Full Disk Access > Press the lock symbol to unlock [bottom right of window]> Select Chrome and add it. > Now restart Chrome.';

  async presentTooltip() {
    const toast = await this.toastController.create({
      message: this.tooltipText,
      duration: 10000,
      position: 'top',
    });
    await toast.present();
  }

  constructor(
    private fb: UntypedFormBuilder,
    private modalController: ModalController,
    private navParams: NavParams,
    private toastController: ToastController,
    private uploadService: UploadService,
  ) {
    const params = this.navParams.data as {
      propertyId: string;
      imgUrl: string;
    };
    this.data = {
      propertyId: params?.propertyId || '',
      imgUrl: params?.imgUrl || '',
    };
    this.propertyId = this.data.propertyId;
    this.imgUrl = this.data.imgUrl;
  }

  detectFiles(evt: Event) {
    this.selectedFile = (<HTMLInputElement>evt.target).files;
  }

  async startUpload() {
    const file = this.selectedFile.item(0);
    this.currentUpload = new Upload(file);
    this.currentUpload.propertyId = this.propertyId;
    const newImgUrl = await this.uploadService.pushUpload(this.currentUpload);
    this.modalController.dismiss(newImgUrl);
  }

  cancelUpload() {
    this.modalController.dismiss(null);
  }

  ngOnInit() {
    this.imageForm = this.fb.group({
      imgUrl: this.fb.control(''),
    });
    this.propertyId = this.data.propertyId;
    this.imgUrl = this.data.imgUrl;
  }
}
